<template>
    <div id="modal-act-proj-menu" class="modal fade">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li v-if="(item.proj_access_flg == '1' || item.proj_access_flg == '3') && (opt == 'opening' || opt == 'private')" 
                            class="list-group-item border-0" @click="sendMail">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-envelope icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">メール配信</span>
                                    <span v-if="!canSend" class="text-danger">(条件不足)</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="(item.proj_access_flg == '1' || item.proj_access_flg == '3') && (opt == 'timeout' || opt == 'opening' || opt == 'private')" 
                            class="list-group-item border-0" @click="updateRecentInDay()">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-retweet icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">受信日更新</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="(item.proj_access_flg == '1' && opt == 'opening') || (item.proj_access_flg == '3' && opt == 'private') || opt == 'timeout' || opt == 'accesslimit'" 
                            class="list-group-item border-0" @click="projOff">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comment-slash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">募集終了にする</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="(item.proj_access_flg == '0' && opt == 'opening') || (opt == 'waiting' || opt =='accesslimit' || opt =='private')" 
                            class="list-group-item border-0" @click="projPublic('1')">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-satellite-dish icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">公開</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="opt != 'accesslimit'" class="list-group-item border-0" @click="projPublic('2')">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-eye-slash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">閲覧制限</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="opt == 'waiting' || opt == 'timeout' || opt == 'opening' || opt == 'closing' || opt == 'accesslimit'" class="list-group-item border-0" @click="projPricePub">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comments-dollar icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">
                                        公開単価 
                                        <span v-if="item.proj_price_pub == '1'" class="text-danger"> (未設定) </span>
                                        <span v-if="item.proj_price_pub == '0'" class="text-success"> (設定済み) </span>
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li v-if="opt == 'waiting' || opt == 'opening'" class="list-group-item border-0" @click="projPublic('3')">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-key icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 内部案件へ</span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="projNote()">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-pen-alt icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">備考</span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="projShare">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-share-alt icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">共有</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="opt == 'delete' || opt == 'accesslimit'" class="list-group-item border-0" @click="projDelete()">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-trash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">削除</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                item: {},
                opt: '',
            }
        },
        mounted () {
            this.menuOpenBusOn()
            this.busOnCmpProjMenuSendmail()
        },
        watch: {
            getCmpProjOffStatus (status) {
                this.setStatus(status)
            },
            getCmpProjPublicStatus (status) {
                this.setStatus(status)
            }
        },
        computed: {
            canSend () {
                return this.item.summary_sys && this.item.summary_title && (this.item.email_flg == '0') ? true : false
            },
            ...mapGetters(['getCmpProjOffStatus', 'getCmpProjPublicStatus', 'getCmpProjPubliced'])
        },
        methods: {
            menuOpenBusOn () {
                EventBus.$on('busOnCmpProjMenu', (data)=> {
                    this.openThis(data.item, data.opt)
                })
            },
            openThis (item, opt) {
                this.resetThis()
                this.item = item
                this.opt = opt
                $('#modal-act-proj-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-act-proj-menu').modal('hide')
            },
            resetThis () {
                this.item = {},
                this.opt = ''
            },
            async setStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    await this.$parent.refreshPage()
                    this.$store.dispatch('doneSpinner')
                    this.hideThis()
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            },
            projDelete () {
                    let lev = 2
                    let msg = '物理削除を行いますか？'
                    let key = 'delete' 
                    this.$parent.openMsg(lev, msg, key, this.item.id)
                    this.hideThis()
            },
            sendMail () {
                if (this.canSend) {
                    EventBus.$emit('busOnOpenInfoMsg', {
                        msg: 'Pj.' + this.item.id + '案件を配信しますか？',
                        lev: 2,
                        emitData: this.item,
                        emitEvt: 'busOnCmpProjMenuSendmail'
                    })
                    this.hideThis()
                }
            },
            busOnCmpProjMenuSendmail () {
                EventBus.$on('busOnCmpProjMenuSendmail', (item=null) => {
                    EventBus.$emit('busOnHideInfoMsg')
                    // メール送信
                    EventBus.$emit('busOnSendMailCommon', {
                        id: item.id,
                        type: '3'
                    })
                })
            },
            updateRecentInDay () {
                this.$store.dispatch('changeCmpProjInfoCommon', {
                    id: this.item.id,
                    processId: 'recentInDay',
                })
                this.hideThis()
            },
            projOff () {
                this.$store.dispatch('cmpProjOff', {
                    id: this.item.id,
                })
            },
            projPublic (flg) {
                this.$store.dispatch('cmpProjPublic', {
                    id: this.item.id,
                    flg: flg
                })
            },
            projPricePub () {
                this.$parent.projPricePub(this.item)
                this.hideThis()
            },
            projShare () {
                this.$parent.projShare(this.item)
                this.hideThis()
            },
            projNote () {
                this.$parent.projNote(this.item)
                this.hideThis()
            }
        }
    }
</script>

<style>

</style>
